// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.74 4.39 C2.31 3.35 3.35 2.31 4.39 2.74 L12.37 6.07 C13.23 6.43 13.22 7.65 12.36 8 L10.07 8.91 C9.54 9.12 9.12 9.54 8.91 10.07 L8 12.36 C7.65 13.22 6.43 13.23 6.07 12.37 Z',
];
